import { GlobalSearchPath } from './../../../constants/global-search-path';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppMainComponent } from '../../../../../app.main.component';
import * as moment from "moment";
import { ObjectNames } from '../../../constants/object.names';
import { AppMainService } from '../../../../../app-main.service';
import { ActivityService } from '../activity.service';
import { MessageService } from 'primeng/api';
import { LogService, NoteService } from '../api/api';
import { EmailAuditService, TaskService } from 'src/app/shared/api/api';
import { EmailAudit } from 'src/app/shared/model/models';
import { SOChannel } from 'src/app/inventory/sales-order/constants/constants';
import { CONTACT_ASSOCIATION_IDS_MODULES } from '../../../constants/typeId';
@Component({
    selector: "app-lion-all-activities-dialog",
    templateUrl: "./all-activities-dialog.component.html",
    styleUrls: ["../shared-activities.component.scss"],
})
export class LionAllActivitiesDialogComponent implements OnChanges {
    @Input() currentDisplay;
    @Input() allActivities: any[] = [];
    @Input() isViewMode = false;
    @Input() selectedObject: any = null;
    @Input() objectTypeId: number;
    @Output() dialogClosed = new EventEmitter<any>();

    filters = {
        ALL_ACTIVITY: 'allactivity',
        USER_ACTIVITY: 'useractivity',
        SYSTEM_ACTIVITY: 'systemactivity',
        LOG: 'log',
        NOTE: 'note',
        EMAIL: 'email',
        FAVORITE: 'favorite'

    };

    searchText = "";
    selectedTimeRange;
    timeRanges = [
        { id: 1, name: "Most recent", value: "mostrecent" },
        { id: 2, name: "Last 7 days", value: "lastsevendays" },
        { id: 3, name: "Last 15 days", value: "lastfifteendays" },
        { id: 4, name: "This week", value: "thisweek" },
        { id: 5, name: "This month", value: "thismonth" },
        { id: 6, name: "Last month", value: "lastmonth" },
        { id: 7, name: "Last 3 months", value: "lastthreemonths" },
        { id: 8, name: "Last 6 months", value: "lastsixmonths" },
        { id: 9, name: "This year", value: "thisyear" },
        { id: 10, name: "Last 1 year", value: "lastoneyear" },
    ];

    currentPage = 1;
    pageSize = 15;

    filteredActivities: any[] = [];
    userActivityData: any[] = [];
    systemActivityData: any[] = [];
    activityLogData: any[] = [];
    activityNoteData: any[] = [];
    activityEmailData: any[] = [];
    isView = true;
    activitySidebar = false;
    hoursDiff;

    // Log
    logData;
    displayLogDetailPopup = false;

    // Note
    noteData;
    displayNoteDetailPopup = false;

    // Email
    displayEmailDetailPopup = false;
    emailAudit: EmailAudit;
    emailAuditId: any;

    //comment modal
    displayCommentAdd: boolean = false;
    tempComment;
    nextStageIdForUpdate;
    commentFormType;
    commentHeaderName: string;

    filterType = this.filters.ALL_ACTIVITY;

    moduleType = '';
    displayDetailPopup = false;
    popupHeader = '';
    dataId;

    objectNames = ObjectNames;
    favoriteClicked = false;

    // Active / Inactive

    activeInactiveFormType: string;
    displayActiveInactiveModal: boolean = false;
    activeInactiveData: any;
    moduleName: string;

    // Email Reply
    displayEmailReplyPopup: boolean = false;
    emailReplyData: any;

    soChannel = SOChannel;

    paths = GlobalSearchPath;

    associationTypeId: number = 0;

    constructor(
        private router: Router,
        public app: AppMainComponent,
        private datePipe: DatePipe,
        private appMainService: AppMainService,
        private activityService: ActivityService,
        private messageService: MessageService,
        private logService: LogService,
        private emailAuditService: EmailAuditService,
        private noteService: NoteService,
        private activityTaskService: TaskService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.currentDisplay?.currentValue) {
            this.currentDisplay = changes?.currentDisplay?.currentValue;
        }

        if (changes?.allActivities?.currentValue) {
            this.allActivities = this.filteredActivities = changes?.allActivities?.currentValue;
            this.userActivityData = this.allActivities.filter(e => (e.type == 'Email' || e.type == 'Log' || e.type == 'Note'));
            this.systemActivityData = this.allActivities.filter(e => e.filter == 'system');
            this.activityLogData = this.allActivities.filter(e => e.type == 'Log');
            this.activityNoteData = this.allActivities.filter(e => e.type == 'Note');
            this.activityEmailData = this.allActivities.filter(e => e.type == 'Email');
        }

        if (changes?.isViewMode?.currentValue) {
            this.isViewMode = changes.isViewMode.currentValue;
        }

        this.app.getAllActivityLogList(this.timeRanges[0].value, this.filters.ALL_ACTIVITY, this.currentPage, this.pageSize, "", true, true);
    }

    loadMore() {
        ++this.currentPage;

        this.appMainService.isShowSpinner('loadActivityLogList');
        this.activityTaskService.getAllActivities(this.app.objectId, this.app.objectTypeId, this.selectedTimeRange.value,
            this.filterType, this.currentPage, this.pageSize, this.searchText, true, true).subscribe((response) => {
                response && response.length > 0 && this.app.allActivityLogsList.push(...response);
                this.appMainService.isHideSpinner('loadActivityLogList');
            }, (error) => {
                if (error) {
                    this.app.allActivityLogsListErrorResponse = error.status;
                }
                this.appMainService.isHideSpinner('loadActivityLogList');
            });
    }

    filterActivities(filterType) {
        this.filterType = filterType;

        this.app.getAllActivityLogList(this.selectedTimeRange.value, filterType, 1, this.pageSize, this.searchText,
            true, true);
    }

    filterActivityByDate() {
        this.app.getAllActivityLogList(this.selectedTimeRange.value, this.filterType, 1, this.pageSize, this.searchText,
            true, true);
    }

    searchKey() {
        // let text = this.searchText.toLowerCase();

        // this.filteredActivities = this.allActivities.filter((val) =>
        //     val.comments[0].message.toLowerCase().includes(text) ||
        //     val.user.toLowerCase().includes(text) ||
        //     val.date.toLowerCase().includes(text) ||
        //     val.message.toLowerCase().includes(text) ||
        //     val.type.toLowerCase().includes(text)
        // );
        this.app.getAllActivityLogList(this.selectedTimeRange.value, this.filters.ALL_ACTIVITY, 1, this.pageSize, this.searchText, true, true);
    }

    openActivityDetail(s) {
        if (this.favoriteClicked) {
            return;
        }

        if (s.activityName == this.objectNames.LOG) {
            this.openLogDetail(s);
        } else if (s.activityName == this.objectNames.NOTE) {
            this.openNoteDetail(s);
        } else if (s.activityName == this.objectNames.EMAIL) {
            this.openEmailDetail(s);
        } else if (s.type == this.objectNames.LEAD) {
            this.openLeadDetail(s);
        } else if (s.type == this.objectNames.CONTACT) {
            this.openContactDetail(s);
        } else if (s.type == this.objectNames.ACCOUNT && s.objectData?.action != 'Convert') {
            this.openAccountDetail(s);
        } else if (s.type == this.objectNames.ACCOUNT && s.objectData?.action == 'Convert') {
            const payloadDetails = s.objectData?.payload ? JSON.parse(s.objectData?.payload) : null;

            if (s.objectData?.objectId == 2 && payloadDetails.LeadId) {

                if (s.lead) {
                    s.lead['id'] = payloadDetails.LeadId;
                } else {
                    s.lead = { id: payloadDetails.LeadId };
                }

                this.openLeadDetail(s);
            } else {

                if (s.account) {
                    s.account['id'] = payloadDetails?.AccountId;
                } else {
                    s.account = { id: payloadDetails?.AccountId };
                }

                this.openAccountDetail(s);
            }

        } else if (s.type == this.objectNames.OPPORTUNITY) {
            this.openOpportunityDetail(s);
        } else if (s.type == this.objectNames.CASE) {
            this.openCaseDetail(s);
        } else if (s.filter == 'system') {
            this.setDetailsPopupData(s);
        } else if (s.type == 'ActivityLeadLog' || s.type == 'ActivityOpportunityLog' || s.type == 'ActivityCaseLog') {
            if (s.objectData) {
                let activity = s.objectData;
                activity['objectType'] = s.type == 'ActivityLeadLog' ? 'Lead' :
                    s.type == 'ActivityOpportunityLog' ? 'Opportunity' : 'Case';
                this.openUpdateStagePopup({ id: activity.stageId, type: 'View', comment: activity });
            }
        }
        else if (s.type == 'StageChange') {
            if (s.objectData) {
                let activity = s.objectData;
                activity['objectType'] = 'Case';
                this.commentFormType = 'Add'; // For hidding
                this.openUpdateStagePopup({ id: activity?.StageId, type: 'View', comment: activity });
            }
        }
        else if (s.type == 'ActiveInactiveContactLog' || s.type == 'ActiveInactiveOpportunityLog'
            || s.type == 'ActiveInactiveAccountLog' || s.type == 'ActiveInactiveLeadLog') {
            if (s.objectData) {
                s.objectData['objectType'] = s.type == 'ActiveInactiveLeadLog' ? 'Lead' :
                    s.type == 'ActiveInactiveOpportunityLog' ? 'Opportunity' :
                        s.type == 'ActiveInactiveAccountLog' ? 'Account' : 'Contact';
                this.openActiveInactiveModal(s);
            }
        }
        else if (s.type == 'EmailReply') {
            this.openEmailReplyPopup(s);
        }
    }

    openActiveInactiveModal(data: any): void {
        let moduleName: string = '';
        switch (data?.type) {
            case 'ActiveInactiveContactLog':
                moduleName = 'Contact';
                break;
            case 'ActiveInactiveOpportunityLog':
                moduleName = 'Opportunity';
                break;
            case 'ActiveInactiveLeadLog':
                moduleName = 'Lead';
                break;
            case 'ActiveInactiveAccountLog':
                moduleName = 'Account';
                break;
        }
        const status: string = (data?.objectData?.status?.id == 1) ? 'Active' : 'Inactive';
        this.commentHeaderName = moduleName + ' ' + status + ' Details';
        this.activeInactiveFormType = 'View';
        this.displayActiveInactiveModal = true;
        this.activeInactiveData = data;
        this.moduleName = moduleName;
    }

    cancelActiveInactiveModal(): void {
        this.commentHeaderName = '';
        this.activeInactiveFormType = '';
        this.moduleName = '';
        this.displayActiveInactiveModal = false;
        this.activeInactiveData = null;
    }

    toggleFavourite(id, isFavorite, filterValue) {
        this.favoriteClicked = true;

        this.appMainService.isShowSpinner("toggleFavourite");

        this.activityService.toggleFavourite(id, isFavorite, filterValue.toLowerCase())
            .then(() => {
                this.appMainService.isHideSpinner("toggleFavourite");

                let summary = filterValue;
                summary += isFavorite ? ' added to favorites' : ' removed from favorites';

                this.messageService.add({ severity: 'success', summary, detail: '' });

                let data = this.app.allActivityLogs.find(data => data.id == id);
                data.isFavorite = isFavorite;

                this.favoriteClicked = false;
            })
            .catch(() => {
                this.appMainService.isHideSpinner("toggleFavourite");
                this.favoriteClicked = false;
            })
    }

    openLogDetail(s) {
        this.appMainService.isShowSpinner('getLogDetails');

        this.logService.lionO36020APILogIdGet(s.objectData.log.id).subscribe((log: any) => {
            this.logData = log;
            this.displayLogDetailPopup = true;
            this.appMainService.isHideSpinner('getLogDetails');
        }, () => {
            this.appMainService.isHideSpinner('getLogDetails');
        });
    }

    openNoteDetail(s) {
        this.appMainService.isShowSpinner('getNoteDetails');

        this.noteService.lionO36020APINoteIdGet(s.objectData.note.id).subscribe(note => {
            this.noteData = note;
            this.displayNoteDetailPopup = true;
            this.appMainService.isHideSpinner('getNoteDetails');
        }, () => {
            this.appMainService.isHideSpinner('getNoteDetails');
        });
    }

    openEmailDetail(s) {
        this.displayEmailDetailPopup = true;
        this.emailAuditId = s.id;
        this.emailAuditService.lionO36020APIEmailAuditIdGet(s.id, true).subscribe((email: any) => {
            let emailAuditDetails: EmailAudit = email;
            emailAuditDetails.emailThreads.forEach(elem => { elem.receivedDateTime = elem.receivedDateTime });
            emailAuditDetails.emailThreads = emailAuditDetails.emailThreads.sort(function (left, right) {
                return moment.utc(right.receivedDateTime).diff(moment.utc(left.receivedDateTime))
            });
            this.emailAudit = emailAuditDetails;
        });
    }

    cancelEmailPopupDetails() {
        //this.emailData = null;
        this.displayEmailDetailPopup = false;
        //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
    }

    openEmailReplyPopup(data: any): void {
        this.displayEmailReplyPopup = true;
        this.emailReplyData = data;
    }

    getEmailReplyActivity(id: number): void {
        this.appMainService.isShowSpinner("emailReplyActivity");
        this.activityService.getEmailReplyActivity(id).then((response) => {
            this.emailReplyData = response;
            this.appMainService.isHideSpinner("emailReplyActivity");
        },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error Occured', detail: error?.error?.message });
                this.appMainService.isHideSpinner("emailReplyActivity");
            });
    }

    cancelEmailReplyPopup(): void {
        this.displayEmailReplyPopup = false;
        this.emailReplyData = null;
    }


    openLeadDetail(s) {
        this.moduleType = this.objectNames.LEADS;
        this.displayDetailPopup = true;
        this.popupHeader = "Lead Details";
        this.dataId = s?.objectData?.objectRecordId;
    }

    openContactDetail(s) {
        this.moduleType = this.objectNames.CONTACT;
        this.displayDetailPopup = true;
        this.popupHeader = "Contact Details";
        this.dataId = s?.objectData?.objectRecordId;
        this.associationTypeId = CONTACT_ASSOCIATION_IDS_MODULES[`OBJECTID_${s?.objectData?.refObjectId}`];
    }

    openAccountDetail(s) {
        this.moduleType = this.objectNames.ACCOUNT;
        this.displayDetailPopup = true;
        this.popupHeader = "Account Details";
        this.dataId = s?.objectData?.objectRecordId;
    }

    openOpportunityDetail(s) {
        this.moduleType = this.objectNames.OPPORTUNITY;
        this.displayDetailPopup = true;
        this.popupHeader = "Opportunity Details";
        this.dataId = s?.objectData?.objectRecordId;
    }

    openCaseDetail(s) {
        this.moduleType = this.objectNames.CASES;
        this.displayDetailPopup = true;
        this.popupHeader = "Case Details";
        this.dataId = s?.objectData?.objectRecordId;
    }

    openUpdateStagePopup(data: { id: number, type: string, comment?: Comment }) {
        this.displayCommentAdd = true;
        this.tempComment = data.comment;
        this.nextStageIdForUpdate = data.id;
        this.commentFormType = data.type;
        if (this.tempComment.objectType == 'Lead') {
            this.commentHeaderName = `${this.tempComment.objectType} Name : ${this.selectedObject?.businessName}`;
        }
        else if (this.tempComment.objectType == 'Case') {
            this.commentHeaderName = `${this.tempComment.objectType} No : ${this.selectedObject?.sequenceNumber}`;
        }
        else {
            this.commentHeaderName = `${this.tempComment.objectType} Name : ${this.selectedObject?.name}`;
        }
    }

    // checkSameDate(d1, d2) {
    //    // //console.log("All activities dialog called");
    //     return new Date(d1).getFullYear() === new Date(d2).getFullYear() &&
    //         new Date(d1).getMonth() === new Date(d2).getMonth() &&
    //         new Date(d1).getDate() === new Date(d2).getDate();
    // }

    // checkHourDiff(t1, t2) {
    // 	let date1 = new Date(t1).getTime();
    // 	let date2 = new Date(t2).getTime();
    // 	let time = date1 - date2;  //msec
    // 	let hour = time / (3600 * 1000);
    // 	if (hour < 0) {
    // 		this.hoursDiff = Math.abs(Math.round(hour)) + " hour ago";
    // 	}
    // 	return Math.round(hour) == 0;
    // }

    setDetailsPopupData(s) {
        // this.displayDetailPopup = true;
        // this.moduleName = s.type;
        // this.popupHeader = s.type + ' Details';
        // this.detailsData = JSON.parse(JSON.stringify(s));

        // if (s.type == 'Case') {
        // 	this.itemRouterLink = '/cases';
        // } else if (s.type == 'Opportunity') {
        // 	this.itemRouterLink = '/opportunities';
        // }
    }

    // filterActivities(filterType){
    // 	this.app.getAllActivityLog(this.selectedTimeRange.value, filterType, 1, 15, this.searchText, true, true);
    // }

    hideDialog() {
        this.currentDisplay = false;
        this.dialogClosed.emit({ "dialogClosed": this.currentDisplay });
    }

    closeDialog() {
        this.displayDetailPopup = false;
    }

    cancelLogPopupDetails() {
        this.logData = null;
        this.displayLogDetailPopup = false;
        //this.app.getAllActivityLog("lastsevendays", this.filters.ALL_ACTIVITY, 1, 10, "", true, true);
    }

    cancelNotePopupDetails() {
        this.noteData = null;
        this.displayNoteDetailPopup = false;
        //this.app.getAllActivityLog("lastsevendays", this.filters.ALL_ACTIVITY, 1, 10, "", true, true);
    }

    convertPageNavigation(s) {

        let url = "";
        const payloadDetails = s.objectData?.payload ? JSON.parse(s.objectData?.payload) : null;
        let businessName = "";
        let splitedText = s.objectData.comment.split(':');
        if (s?.objectData?.comment && splitedText.length > 1) {
            businessName = splitedText[1]?.trim();
        }

        let queryParams = {
            id: 0,
            channelId: payloadDetails?.TypeId || 1,
            module: s.type,
            statusId: payloadDetails?.StatusId || 1,
            globalSearch: true,
            data: businessName,
        };

        if (s.objectData?.objectId == 2 && payloadDetails?.LeadId) {
            url = this.paths.Lead;
            queryParams.id = payloadDetails.LeadId;
            queryParams.module = 'Leads';
        } else {
            url = this.paths.Account;
            queryParams.id = payloadDetails?.AccountId;
            queryParams.module = 'Account';
        }

        this.router
            .navigateByUrl("/", { skipLocationChange: true })
            .then(() =>
                this.router.navigate([url], {
                    queryParams
                })
            );
    }
}
